module.exports = __webpack_public_path__ + "static/media/calendar-placeholder.e49e0ce5.svg";